/**
 * Which listings the signed-in traveller has already booked.
 *
 * Presentation-only, and deliberately NOT part of `utils/booking.js` — that
 * module is mirrored byte-for-byte against the provider app's `lib/booking.ts`
 * and must not grow client-side helpers.
 *
 * v2 bookings expose `listingId`; v1 stored the listing id under a key named
 * `serviceProvider`. Both shapes are read here, because reading
 * `.serviceProvider.id` unguarded threw on every v2 booking.
 */

export function bookedListingIds(bookings) {
  return (bookings || [])
    .map((b) => b?.listingId || b?.listing?.id || b?.serviceProvider?.id)
    .filter(Boolean);
}

export function isListingBooked(bookings, listingId) {
  if (!listingId) return false;
  return bookedListingIds(bookings).includes(listingId);
}
